import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { updatejob, addjobimporting, getJobDetail } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter } from 'reactstrap';

//import { Importer, ImporterField } from "react-csv-importer";

// theme CSS for React CSV Importer
//import "react-csv-importer/dist/index.css";

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class viewjob extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export',
      blockinstopenmodal:false,
      suggestions: [],
      institute:'',
      pickedones:[],
      pickedinstIds:[],
      salary_range_forthisjob: 15000,
      organisation_place:'',
      organisation:'',
      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true,
      importopen:false,
      job:[]
    }

    this.job_id = this.props.match.params.jobid;

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.importopen = this.importopen.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
          this.getJobDetail();    

  }


  getJobDetail(){

    let req = JSON.stringify({
        job_id:this.job_id
    });

    getJobDetail(req).then((response) => {
      
        if(response.status==1){
            this.setState({job:response.detail});     
        }
        else{
            this.setState({job:[]});
        }


    })


  }
  

  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };

  importopen(){
    this.setState({importopen:true});
  }

  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{

    var auth_data = JSON.parse(localStorage.getItem("user_data"));

    let req = JSON.stringify({
        job_id:this.job_id,
        user_id:auth_data.user_id,
        job_title: this.state.job_title,
        job_category: this.state.job_category,
        job_description: this.state.job_description,
        job_gender:this.state.job_gender,
        organisation:auth_data.organisation,
        organisation_place:auth_data.organisation_place,
        open_date: this.state.open_date,
        closing_date: this.state.closing_date,
        job_location: this.state.job_location,
        salary_range_forthisjob: this.state.salary_range_forthisjob,
        language_preferred: this.state.language_preferred,
        expected_qualification: this.state.expected_qualification,
        skillsrequired: this.state.skillsrequired,
        job_role: this.state.job_role,
        job_subject_teaching: this.state.job_subject_teaching,
        job_experience: this.state.job_experience,
        examcertifications: this.state.examcertifications,
        expected_qualification_other: this.state.expected_qualification_other,
        skillsrequired_other: this.state.skillsrequired_other,
        job_role_other: this.state.job_role_other,
        job_subject_teaching_other: this.state.job_subject_teaching_other,
        examcertifications_other: this.state.examcertifications_other

    })
    
    updatejob(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Updated job successfully', 'Edit job');

      }else{
            
        NotificationManager.error('Error updating a job', 'Edit job');
      }

    });
}

 
  
 
  render() {
 const {job} = this.state;

  const { salary_range_forthisjob } = this.state
    const horizontalLabels = {
      12000: '12k',
      400000: '4L'
    }

    const formatkg = value => value;
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                    <div class="boxtitle"><img src="../../../images/profile/about.png" />Edit job</div>
                    <div class="importbox">
                       <button class="btn btn-primary" onClick={this.importopen}>Import bulk</button>
                    </div>
                    <div class="postajobform wc">

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job title </label>
<input type="text" class="form-control forminputcls" id="job_title" name="job_title" value={job.job_title}  onChange={this.handleChange}/>
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Job Description </label>
<textarea class="form-control forminputcls" name="job_description" id="job_description" value={job.job_description}  placeholder="Description" rows="10" onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job role</label>
<select name="job_role" class="formselectinputcls" value={job.job_role}  onChange={this.handleChange}> 
            <option value="">Select Role</option>
            <option value="Pre Primary Teacher">Pre Primary Teacher</option>
            <option value="Primary Teacher">Primary Teacher</option>
            <option value="Secondary Teacher">Secondary Teacher</option>
            <option value="Senior Secondary Teacher">Senior Secondary Teacher</option>
            <option value="Special Educator">Special Educator</option>
            <option value="Libraian">Libraian</option>
            <option value="Physial Education Teacher">Physial Education Teacher</option>
            <option value="Counsellor">Counsellor</option>
            <option value="Administrator">Administrator</option>
            <option value="Accountant">Accountant</option>
            <option value="Marketing">Marketing</option>
            <option value="Music / Dance Teacher">Music / Dance Teacher</option>
            <option value="Other">Other</option>
</select>
</div> 
<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job Role - If Other </label>
<input type="text" class="form-control forminputcls" id="job_role_other" value={job.job_role_other} disabled={this.state.job_role_other_disabled} name="job_role_other"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Gender</label>
<select name="job_gender" class="formselectinputcls" value={job.job_gender}  onChange={this.handleChange}> 
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
            <option value="Not a constraint">Not a constraint</option>
</select>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Role Type</label>
<select name="job_category" value={job.job_category} class="formselectinputcls"  onChange={this.handleChange}> 
            <option value="">Select Role Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
            <option value="Contractual">Contractual</option>
            <option value="Temporary">Temporary</option>
            <option value="Internship">Internship</option>
</select>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Subject Of Teaching</label>
<select name="job_subject_teaching" value={job.job_subject_teaching}  class="formselectinputcls"  onChange={this.handleChange}> 
            <option value="">Select Subject</option>
            <option value="Biology">Biology</option>
            <option value="Science">Science</option>
            <option value="Maths">Maths</option>
            <option value="Physics">Physics</option>
            <option value="Chemistry">Chemistry</option>
            <option value="Art">Art</option>
            <option value="History">History</option>
            <option value="Economics">Economics</option>
            <option value="Computer Science">Computer Science</option>
            <option value="Phyisical Education">Phyisical Education</option>
            <option value="Librarian">Librarian</option>
            <option value="Humanities">Humanities</option>
            <option value="Geography">Geography</option>
            <option value="Civics">Civics</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Tamil">Tamil</option>
            <option value="Kannada">Kannada</option>
            <option value="Telugu">Telugu</option>
            <option value="Marathi">Marathi</option>
            <option value="French">French</option>
            <option value="Spanish">Spanish</option>
            <option value="German">German</option>
            <option value="Reglion and Religious Studies">Reglion and Religious Studies</option>
            <option value="Visual Arts">Visual Arts</option>
            <option value="Robotics & Coding">Robotics & Coding</option>
            <option value="Other">Other</option>
</select>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Subject Of Teaching - If Other </label>
<input type="text" class="form-control forminputcls" id="job_subject_teaching_other" value={job.job_subject_teaching_other} disabled={this.state.job_subject_teaching_other_disabled} name="job_subject_teaching_other"   onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Experience Required </label>
<select name="job_experience" class="formselectinputcls" value={job.job_experience}  onChange={this.handleChange}> 
            <option value="">---Select---</option>
            <option value="Freshers">Freshers</option>
            <option value="0-3 Years">0-3 Years</option>
            <option value="4-5 years">4-5 years</option>
            <option value="5-10 years">5-10 years</option>
            <option value="10-15 years">10-15 years</option>
            <option value="15+ years">15+ years</option>
        </select>
</div> 
 
<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Anticipated joining </label>
<select name="joining" class="formselectinputcls" value={job.joining} onChange={this.handleChange}> 
            <option value="">---Select---</option>
            <option value="Immediate">Immediate</option>
            <option value="15 Days">15 Days</option>
            <option value="1 month">1 month</option>
            <option value="2 months">2 months</option>
            <option value="3 months">3 months</option>
        
        </select>
</div> 

<div class="formgroup">
<label for="exampleInputPassword1">Job Opening Date </label>

<input type="date" class="form-control forminputcls" id="open_date" value={job.open_date} name="open_date"   onChange={this.handleChange}/>


</div> 
<div class="formgroup">
<label for="exampleInputPassword1">Job Closing Date </label>

<input type="date" class="form-control forminputcls" id="closing_date" value={job.closing_date}  name="closing_date"   onChange={this.handleChange}/>


</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job Location </label>
 
        <select name="job_location" class="formselectinputcls" value={job.job_location} onChange={this.handleChange}>

            <option value="">Select</option>
            <option value="In Campus">In Campus</option>
            <option value="Hybrid">Hybrid</option>
            <option value="Remote">Remote</option>
        </select>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Salary Range for this Job</label>
<Slider
    min={10000}
    max={400000}
    value={salary_range_forthisjob}
    labels={horizontalLabels}
    format={formatkg}
    step={1000}
    handleLabel={salary_range_forthisjob}
    onChange={this.handleChangeHorizontal}
    />
</div> 
<div id="salaryText">
    &#8377; {formatkg(salary_range_forthisjob)}
</div>
<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Languages preferred </label>
 
        <select name="language_preferred" multiple multiselect class="formselectinputcls" onChange={this.handleChange}>
            <option value="">Select Language</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Tamil">Tamil</option>
            <option value="Kannada">Kannada</option>
            <option value="Telugu">Telugu</option>
            <option value="Urdhu">Urdhu</option>
            <option value="Malayalam">Malayalam</option>
        </select>
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Expected Qualification </label>

<select name="expected_qualification" multiple class="formselectinputcls" onChange={this.handleChange}>
            <option value="">Select Qualification</option>
            <option value="Graduate in Education (BA / B.SC etc.)">Graduate in Education (BA / B.SC etc.)</option>
            <option value="Post Graduate (MA /M.Sc etc)">Post Graduate (MA /M.Sc etc)</option>
            <option value="Engeneering Graduate">Engeneering Graduate</option>
            <option value="Diploma In Education">Diploma In Education</option>
            <option value="Bachelors Degree in Education (B.Ed)">Bachelors Degree in Education (B.Ed)</option>
            <option value="Masters Degree in Education (M.Ed)">Masters Degree in Education (M.Ed)</option>
            <option value="Doctorate (Phd)">Doctorate (Phd)</option>
            <option value="Bachelor of Elementray Education (B.EL.Ed)">Bachelor of Elementray Education (B.EL.Ed)</option>
            <option value="Bachelor of Arts & Education (BA. B.Ed)">Bachelor of Arts & Education (BA. B.Ed)</option>
            <option value="Diploma in Elementary Education (D.EL.Ed)">Diploma in Elementary Education (D.EL.Ed)</option>
            <option value="Bachelor of Physical Education (B.P.Ed)">Bachelor of Physical Education (B.P.Ed)</option>
            <option value="Master of Philosophy in Education (M.Phil)">Master of Philosophy in Education (M.Phil)</option>
            <option value="Bachelor of Library Science (B.Lib)">Bachelor of Library Science (B.Lib)</option>
            <option value="Bachelor of Library & Information Sciences (B.Lib.I.Sc)">Bachelor of Library & Information Sciences (B.Lib.I.Sc)</option>
            <option value="Masters in Library & Information Sciences (M.Lib.I.Sc)">Masters in Library & Information Sciences (M.Lib.I.Sc)</option>
            <option value="Bachelor of Fine Arts (BFA)">Bachelor of Fine Arts (BFA)</option>
            <option value="Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)">Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)</option>
            <option value="Post Graduate Diploma in Special Education">Post Graduate Diploma in Special Education</option>
            <option value="Graduate in Special Education  (B.Ed - Spl Education)">Graduate in Special Education  (B.Ed - Spl Education)</option>
            <option value="Other">Other</option>
</select>

</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Expected Qualification - If Other </label>
<input type="text" class="form-control forminputcls" id="expected_qualification_other" name="expected_qualification_other" disabled={this.state.expected_qualification_other_disabled}  onChange={this.handleChange}/>
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Entrance Examination & Certifications Required  </label>

<select name="examcertifications" multiple class="formselectinputcls" onChange={this.handleChange}>
            <option value="">Select</option>
            <option value="None">None</option>
            <option value="Central Teachers Eligibliity Test (CTET)">Central Teachers Eligibliity Test (CTET)</option>
            <option value="National Eligibility Test (NET / UGC-NET)">National Eligibility Test (NET / UGC-NET)</option>
            <option value="Basic Training Certificates">Basic Training Certificates</option>
            <option value="Primary Teachers Certificates">Primary Teachers Certificates</option>
            <option value="Teachers Training Certificates">Teachers Training Certificates"</option>
            <option value="Teacher Eligiblity Test (TET)">Teacher Eligiblity Test (TET)</option>
            <option value="State Teachers Eligiblity Test (STET)">State Teachers Eligiblity Test (STET)</option>
            <option value="Certificate course in Library Sciences">Certificate course in Library Sciences</option>
            <option value="Certificate course in Drawing teacher training">Certificate course in Drawing teacher training</option>
            <option value="Certificate in Care giving program">Certificate in Care giving program</option>
            <option value="Certificate program in Special Education">Certificate program in Special Education</option>
            <option value="Certicate Courses in Dance">Certicate Courses in Dance</option>
            <option value="Certicate Courses in Arts">Certicate Courses in Arts</option>
            <option value="Certificate Courses in Sports">Certificate Courses in Sports</option>
            <option value="Certificate Courses in Music & Dance">Certificate Courses in Music & Dance</option>
            <option value="Other">Other</option>
</select>

</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Examination and Certifications - If Other </label>
<input type="text" class="form-control forminputcls" id="examcertifications_other" name="examcertifications_other" disabled={this.state.examcertifications_other_disabled}  onChange={this.handleChange}/>
</div> 



<div class="formgroup">
<label for="exampleInputPassword1">Skills required </label>
<select name="skillsrequired" multiple class="formselectinputcls" onChange={this.handleChange}>
            <option value="">Select</option>
            <option value="Expertise in specific subjects of teaching">Expertise in specific subjects of teaching</option>
            <option value="Written and verbal communication">Written and verbal communication</option>
            <option value="Ability to adapt to different situations">Ability to adapt to different situations</option>
            <option value="Knowledge of teaching software and tools">Knowledge of teaching software and tools</option>
            <option value="Ability to teach students experiencing challenge with learning">Ability to teach students experiencing challenge with learning</option>
            <option value="Time management skills">Time management skills</option>
            <option value="Innovative training strategies">Innovative training strategies</option>
            <option value="Flexibility to modify training principles">Flexibility to modify training principles</option>
            <option value="Classroom management">Classroom management</option>
            <option value="Leadership">Leadership</option>
            <option value="Conflict management">Conflict management</option>
            <option value="Collaborative & Interpersonal skills">Collaborative & Interpersonal skills</option>
            <option value="Creative">Creative</option>
            <option value="Financial Management">Financial Management</option>
            <option value="Human Resource Management">Human Resource Management</option>
            <option value="Curriculam Development">Curriculam Development</option>
            <option value="School Policy Knowledge">School Policy Knowledge</option>
            <option value="Understanding & Implementation of NEP requirements">Understanding & Implementation of NEP requirements</option>
            <option value="Other">Other</option>

  </select>
</div>

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Skills required - If Other </label>
<input type="text" class="form-control forminputcls" id="skillsrequired_other" name="skillsrequired_other" disabled={this.state.skillsrequired_other_disabled}  onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="admin_approval_option">
<label for="exampleInputPassword1">Admin Approvals </label>
{job.job_approval==0 &&
    <div><div class="orangetext">Pending</div></div>
}
{job.job_approval==2 &&
    <div><div class="redtext">On Hold</div> <div class="notesbyadmin"><b>Admin Notes:</b><span>testestes test test</span></div></div>
}
{job.job_approval==1 &&
    <div><div class="greentext">Approved</div></div>
}
</div> 

{job.job_status==1 &&
<div class="formgroup">
<label for="exampleInputPassword1">Job Status </label>
<select name="job_status" class="formselectinputcls" value={this.state.job_status} onChange={this.handleChange}>
            <option value="">Select status</option>
            <option value="1">Open</option>
            <option value="2">Closed</option>
            <option value="3">On-Hold</option>
</select>
</div>
}

<div class="formgroup text-center paddingtop20">
{job.submitted==1 &&
  <button type="button" name="postajob" class="btn-main" onClick={this.handleSubmit}>Update</button>
}
</div> 

</div>


                   </div>
              </div>

            </div> 


            <Modal size="lg" style={{maxWidth: '700px', width: '100%'}}  isOpen={this.state.importopen} className="modalpopup">
            <ModalHeader>Import jobs</ModalHeader>
              <ModalBody>

              { /*
              <Importer

      dataHandler={async (rows) => {
        // required, receives a list of parsed objects based on defined fields and user column mapping;
        // may be called several times if file is large
        // (if this callback returns a promise, the widget will wait for it before parsing more data)
        console.log("received batch of rows", rows);

                var auth_data = JSON.parse(localStorage.getItem("user_data"));
                for(let row of rows){
                    let req = JSON.stringify({
                        user_id:auth_data.login_id,
                        job_title: row.job_title,
                        job_category: row.job_category,
                        job_description: row.job_description,
                        organisation:auth_data.organisation,
                        organisation_place:auth_data.organisation_place
                    })
                    
                    await addjobimporting(req);
                }

        // mock timeout to simulate processing
        //await new Promise((resolve) => setTimeout(resolve, 500));
      }}
      chunkSize={10000} // optional, internal parsing chunk size in bytes
      defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
      restartable={false} // optional, lets user choose to upload another file when import is complete
      onStart={({ file, fields }) => {
        // optional, invoked when user has mapped columns and started import
        console.log("starting import of file", file, "with fields", fields);
      }}
      onComplete={({ file, fields }) => {
        // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
        console.log("finished import of file", file, "with fields", fields);
      }}
      onClose={() => {
        // optional, invoked when import is done and user clicked "Finish"
        // (if this is not specified, the widget lets the user upload another file)
        this.setState({importopen:false});
        window.location.href="/partner/wcdashboard";
      }}
    >
      <ImporterField name="job_title" label="Job Title" />
      <ImporterField name="job_category" label="Job Category" />
      <ImporterField name="job_description" label="Description" optional />
    </Importer> */ }

              </ModalBody>
            </Modal>
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default viewjob;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/viewjob.jsx